import { render } from "./SchedaUtente.vue?vue&type=template&id=a62d4e24"
import script from "./SchedaUtente.vue?vue&type=script&lang=js"
export * from "./SchedaUtente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__